/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import { action } from '@ember/object';
import { Editor } from 'cio/services/editor';
import ComposerEditableEntity from 'cio/utils/composer/composer-editable-entity';

interface SwitchToCodeEditorButtonArgs {
  editableEntity: ComposerEditableEntity;
}

export default class SwitchToCodeEditorButton extends Component<SwitchToCodeEditorButtonArgs> {
  @tracked isShowingConfirmationModal = false;

  parcelEditorUXImage = new URL('cio/assets/images/parcel-editor-ux-2x.gif', import.meta.url).toString();

  @action
  toggleToCodeEditor() {
    let { template } = this.args.editableEntity;
    if (template != null) {
      template.editor = Editor.CODE;
    }

    this.isShowingConfirmationModal = false;
  }
}
